import type { ColumnsType } from "antd/es/table";
import { AllBusinessDataTypes } from "../../../types/AllBusinessTypes";
import { Tag } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";

export const AllBusinessesColumns = (): ColumnsType<AllBusinessDataTypes> => [
  {
    title: "Business Name",
    dataIndex: "name",
    key: "name",
    render: (value?: string) => value ?? "-",
  },
  {
    title: "Client Number",
    dataIndex: "clientNumber",
    key: "clientNumber",
    render: (value?: number) =>
      value !== null && value !== undefined ? value : "-",
  },
  {
    title: "Last Taken",
    dataIndex: "lastTaken",
    key: "lastTaken",
    render: (date?: string) => {
      if (!date || !moment(date).isValid()) return "-";
      return moment(date).format("MMM DD, YYYY");
    },
  },
  {
    title: "Redflag Status",
    dataIndex: "redFlagStatus",
    key: "redFlagStatus",
    render: (status?: boolean) => {
      if (status === null || status === undefined) return "-";
      return status ? <Tag color="red">Yes</Tag> : <Tag>No</Tag>;
    },
  },
  {
    title: "Action",
    dataIndex: "_id",
    key: "_id",
    render: (id: string, record: AllBusinessDataTypes) => (
      <Link
        state={{ companyId: record?._id }}
        to={`/user-files-session-history/${encodeURIComponent(record?.name)}`}
        className="table_pill_btn table_pill_btn--view"
        onClick={() => {
          record?.hrEmails && localStorage.setItem("Hremail", JSON.stringify(record.hrEmails));
        }}
      >
        View Clients
      </Link>
    ),
  },
];
